import {WorkspaceTabs} from "./WorkspaceTabs";
import SideBarWrapper from "../../components/SideBarWrapper/SideBarWrapper";
import {useParams} from "react-router-dom";
import ProjectTitle from "../../components/ProjectTitle";
import {useEffect, useState} from "react";
import {fetchProjectDetails} from "./DesignTab/utils";

export const Workspace = () => {
    const {projectId} = useParams();
    const [projectDetails, setProjectDetails] = useState({});
    const [activeTab, setActiveTab] = useState(0);

    function refreshProject() {
        fetchProjectDetails(projectId).then(data => {
            if (data !== null)
                setProjectDetails(data);
        });
    }
    useEffect(()=> {
        refreshProject();
    },[projectId]);


    return (
        <SideBarWrapper titleComponent={<ProjectTitle name={projectDetails?.name} status={projectDetails?.status} region={projectDetails?.region} activeTab={activeTab} refreshProject={refreshProject}/> }>
            <WorkspaceTabs activeTab={activeTab} setActiveTab={setActiveTab}/>
        </SideBarWrapper>
    )
};